<template>
    <li>
        <div class="uk-grid-small" uk-grid>

            <div v-if="product.ShopItem.image.src" class="uk-width-1-4 uk-width-1-5@m uk-first-column">
                <a :href="product.ShopItem.href">
                    <img class="uk-border-rounded"
                         :src="product.ShopItem.image.src">
                </a>
            </div>

            <div v-else class="uk-width-1-4 uk-width-1-5@m uk-first-column">
                <a :href="product.ShopItem.href">
                    <div id="tm-main-images" class="tm-no-image-link-border uk-position-relative">
                        <canvas width="200" height="200"></canvas>
                        <div class="tm-no-image tm-no-image-navbar-cart uk-flex uk-flex-column uk-flex-center uk-flex-middle">
                            <span class="uk-icon" uk-icon="icon: image;ratio: 1;"></span>
                            <span>No image</span>
                        </div>
                    </div>
                </a>
            </div>

            <div class="uk-width-expand">
                <div class="uk-grid-small" uk-grid>

                    <div class="uk-width-expand uk-first-column">
                        <div class="uk-text-meta uk-text-xsmall">{{ product.ShopGroup.name }}</div>
                        <div>
                            <a class="uk-display-inline-block uk-text-small" :href="product.ShopItem.href">{{
                                product.ShopItem.name }}</a>
                        </div>
                    </div>

                </div>

                <div v-if="selectedPrice.ShopItemPrice.on_request === 0" class="uk-flex uk-flex-middle uk-margin-xsmall-top uk-text-xsmall">
                    <span class="uk-margin-xsmall-left">{{ ShopOrderItem.quantity }}</span>
                    <span class="uk-margin-xsmall-left">×</span>
                    <span class="uk-margin-xsmall-left">{{ selectedPrice.ShopItemPrice.calculated_price }} руб. </span>
                    <div class="uk-flex-1"></div>
                    <b>{{ ShopOrderItem.amount }} руб.</b>
                </div>
                <div v-else class="uk-flex uk-flex-middle uk-margin-xsmall-top uk-text-xsmall">
                    <span class="uk-margin-xsmall-left">{{ ShopOrderItem.quantity }}</span>
                    <span class="uk-margin-xsmall-left"></span>
                    <span class="uk-margin-xsmall-left"></span>
                    <b>По запросу</b>
                </div>
            </div>

        </div>
    </li>

</template>

<script>
    export default {
        name: "CartNavbarItem",
        props: {
            product: {
                type: Object,
                required: true
            },
            ShopOrderItem: {
                type: Object
            },
            ShopItemPrices: {
                type: Array
            }
        },
        computed: {
            selectedPrice() {
                return this.ShopItemPrices.find(price => {
                    return price.ShopItemPrice.id === this.ShopOrderItem.price_id
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CartNavbarItem.vue?d231cf70